export enum EntityStatus {
    Open = 1,
    Closed = 2
}